// constants.ts
export var DEFAULT_AMOUNT_OF_WORDS = 36;
export var DEFAULT_READ_MORE_LABEL = 'Read More';
export var DEFAULT_READ_LESS_LABEL = 'Read Less';
